<template>
  <div class="row">
    <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 mb-4 mb-md-0">
      <div class="card py-3">
        <div class="card-body">
          <h4 class="card-title text-center">{{ $t("membership30Days") }}</h4>

          <p class="text-center text-danger">{{ $t("withoutAffiliate") }}</p>

          <div class="text-center">
            <router-link
              :to="{ name: 'membership.extend.30' }"
              class="btn btn-secondary"
            >
              <i18n-t keypath="extend30DaysWithPrice" tag="span">
                <span>{{ product30.price }}</span>
              </i18n-t>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 mt-md-5">
      <div class="card py-3">
        <div class="card-body">
          <h4 class="card-title text-center">{{ $t("membership360Days") }}</h4>

          <p class="text-center text-success">{{ $t("withAffiliate") }}</p>

          <div class="text-center">
            <p class="text-decoration-line-through">
              {{ product30.price * 12 }} € / {{ $tc("days", 360) }}
            </p>

            <router-link
              :to="{ name: 'membership.extend.360' }"
              class="btn btn-secondary"
            >
              <i18n-t keypath="extend360DaysWithPrice" tag="span">
                <span>{{ product360.price }}</span>
              </i18n-t>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Index",
  computed: {
    products() {
      return this.$store.getters["membership/getProducts"];
    },
    
    product360() {
      return this.products["360"];
    },
  },
};
</script>

<style scoped></style>
